import { BehaviorSubject, Observable } from 'rxjs';
import { CollectionViewer, DataSource } from '@angular/cdk/collections';
import { catchError, finalize } from 'rxjs/operators';

import { of } from 'rxjs';
import { GenericDocumentList } from './genericDocumentList';
import { GenericDocumentListService } from '../services/genericDocumentList.service';
import { GenericDocumentListFilter } from './genericDocumentListFilter';

export class GenericDocumentDataSource implements DataSource<GenericDocumentList> {

    private genericDocumentsSubject = new BehaviorSubject<GenericDocumentList[]>([]);
    private loadingSubject = new BehaviorSubject<boolean>(false);
    private totalSubject = new BehaviorSubject<number>(0);

    // eslint-disable-next-line @typescript-eslint/member-ordering
    public loading$ = this.loadingSubject.asObservable();
    // eslint-disable-next-line @typescript-eslint/member-ordering
    public totalItems$ = this.totalSubject.asObservable();

    constructor(private service: GenericDocumentListService) { }

    connect(collectionViewer: CollectionViewer): Observable<GenericDocumentList[]> {
        return this.genericDocumentsSubject.asObservable();
    }

    disconnect(collectionViewer: CollectionViewer): void {
        this.genericDocumentsSubject.complete();
        this.loadingSubject.complete();
        this.totalSubject.complete();
    }

    loadDocuments(filter = new GenericDocumentListFilter()): void {

        this.loadingSubject.next(true);

        this.service.findAll(filter).pipe(
            catchError(() => of([])),
            finalize(() => this.loadingSubject.next(false))
        ).subscribe(data => {
            if (data && data.content) {
                this.genericDocumentsSubject.next(data.content as GenericDocumentList[]);
                this.totalSubject.next(data.totalElements as number);
            } else if (data) {
                this.genericDocumentsSubject.next(data as GenericDocumentList[]);
                this.totalSubject.next(data.length as number);
            } else {
                this.genericDocumentsSubject.next([]);
                this.totalSubject.next(0);
            }
        });
    }

}
